var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { Reaction } from '../../../utils/mobx/Reaction';
import { runtime } from '../../runtime/Runtime';
import { head } from '../../../utils/helper/lodash_replacements';
import { bound } from '../../../utils/decorators/basic';
export class MediaStarter {
    parent;
    wasAutoplaySuccessful = false;
    wasAutoplayTested = false;
    wasAutoplayTestingTriggered = false;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        this.start = new Reaction({
            when: () => this.nextPlaybackToStart,
            action: this.startNextPlayback,
            name: 'startNextPlayback',
            onlyIfTrue: true,
            setupWhenIdle: true,
        });
    }
    start;
    get app() {
        return this.parent.parent;
    }
    get isAutoPlayPossible() {
        if (!this.wasAutoplayTestingTriggered) {
            this.wasAutoplayTestingTriggered = true;
            this.tryAudioAutoplay();
        }
        return this.wasAutoplaySuccessful;
    }
    get isMediaRestrainedUntilFirstUserInteraction() {
        if (!runtime.isBrowserRuntime)
            return false;
        if (this.playbacksToStart.length === 0)
            return false;
        if (this.isAutoPlayPossible)
            return false;
        if (!this.wasAutoplayTested)
            return false;
        return true;
    }
    get playbacksToStart() {
        if (runtime.isBot)
            return [];
        if (!this.isAutoPlayPossible)
            return [];
        if (this.app.appClock.isAppClockPaused)
            return [];
        // const refreshByTime = runtime.runtimeClock.clock_1000.tickingTime;
        return this.app.mediaPlayer.playerIntents.pendingIntents.filter(intent => intent.intentStart.shouldStart);
    }
    get nextPlaybackToStart() {
        if (this.playbacksToStart.length === 0)
            return undefined;
        return head(this.playbacksToStart);
    }
    startNextPlayback(now) {
        // console.log('startNextPlayback');
        // If video, abort all other running videos
        now.intentHandler.play();
    }
    // https://github.com/video-dev/can-autoplay#installation
    async tryAudioAutoplay() {
        if (runtime.solidBrowserRuntime.browserAgent.isSafari) {
            // safari currently cannot autoplay sounds https://stackoverflow.com/questions/3009888/autoplay-audio-files-on-an-ipad-with-html5
            document.addEventListener('touchstart', e => {
                this.wasAutoplaySuccessful = true;
            });
            return;
        }
        if (!window.canAutoplay) {
            await runtime.solidBrowserRuntime.browserIncludes.includeJSFileOnce('/lib/canautoplay/build/can-autoplay.js');
        }
        const { result, error } = await window.canAutoplay.audio();
        runtime.runtimeScheduler.addToNextStateChange(() => (this.wasAutoplayTested = true));
        if (result === false) {
            console.warn('Autoplay Error did occur: ', error);
        }
        if (result === true) {
            runtime.runtimeScheduler.addToNextStateChange(() => (this.wasAutoplaySuccessful = true));
        }
        else {
            setTimeout(this.tryAudioAutoplay, 2000);
        }
    }
}
__decorate([
    observable
], MediaStarter.prototype, "wasAutoplaySuccessful", void 0);
__decorate([
    observable
], MediaStarter.prototype, "wasAutoplayTested", void 0);
__decorate([
    computed
], MediaStarter.prototype, "isAutoPlayPossible", null);
__decorate([
    computed
], MediaStarter.prototype, "playbacksToStart", null);
__decorate([
    computed
], MediaStarter.prototype, "nextPlaybackToStart", null);
__decorate([
    action.bound
], MediaStarter.prototype, "startNextPlayback", null);
__decorate([
    bound
], MediaStarter.prototype, "tryAudioAutoplay", null);
